<template>
    <div>
        <div v-if="dropownLoader">
            <Loader />
        </div>

        <div v-else class="tw-mx-2  tw-mt-4">
            <div class="card tw-flex  tw-flex-col md:tw-flex-row tw-justify-between tw-items-start tw-w-full tw-border-0 tw-p-4 tw-mb-4 tw-bg-white tw-rounded-lg">
                    <div id="werehouseDateRange" class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-w-full tw-gap-4">
                        <div class="tw-w-full md:tw-w-auto">
                            <div
                                class="tw-text-[#050A13] tw-text-xs sm:tw-text-sm md:tw-text-base tw-mb-2 sm:tw-mb-3 tw-mx-1">
                                Date
                            </div>
                            <date-range-picker v-model="dateRange" :show-dropdowns="true" opens="right"
                                :autoApply="true" :locale-data="{ format: 'dd mmm yyyy' }" :max-date="maxDate"
                                @update="formateDate" class="tw-w-full tw-min-w-0">
                            </date-range-picker>
                        </div>
                        <div class="customMultiselectCommon tw-w-full md:tw-max-w-[200px]">
                            <div class="tw-text-[#050A13] tw-text-[12px] sm:tw-text-[14px] tw-mb-2 sm:tw-mb-3 tw-mx-1">
                                Channel
                            </div>
                            <multiselect v-model="selectedChannel" :options="channelList" :multiple="false"
                                :searchable="false" placeholder="Select Channel" label="label" track-by="key"
                                class="tw-w-full tw-mt-2" :showLabels="false" :close-on-select="true" :allow-empty="false"
                                @select="dataAPIs">
                            </multiselect>
                        </div>
                    </div>
                    <div class="tw-w-full md:tw-w-[32rem] tw-mt-4 md:tw-mt-6">
                        <b-button-toolbar
                            class=""
                            aria-label="Toolbar with buttons group"
                            >
                            <b-form-radio-group
                                class="radiohide text-xs"
                                id="radiosBtn"
                                buttons
                                button-variant="outline-secondary"
                                v-model="selectedInterval"
                                name="radiosBtn"
                            >
                                <b-form-radio
                                class="mx-0"
                                value="15"
                                >15 mins</b-form-radio
                                >
                                <b-form-radio
                                class="mx-0"
                                value="30"
                                >30 mins</b-form-radio
                                >
                                <b-form-radio
                                class="mx-0"
                                value="45"
                                >45 mins</b-form-radio
                                >
                                <b-form-radio
                                class="mx-0 text-xs"
                                value="60"
                                >60 mins</b-form-radio
                                >
                            </b-form-radio-group>
                        </b-button-toolbar>
                    </div>
            </div>
            <div class="card tw-border-0 summaryContainer tw-m-0 tw-mb-4  tw-z-[10]">
                <div>
                    <div
                        class="tw-flex  sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4] tw-gap-4">
                        <div
                            class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">
                            Daily Run Rate</div>
                        <div class="tw-flex sm:tw-flex-row tw-gap-2">
                            <button
                                class="ui button exportButton tw-ml-0 sm:tw-ml-1 tw-text-sm sm:tw-text-base tw-px-3 sm:tw-px-6 tw-py-2"
                                @click="exportTotalOrdersData">
                                <svg v-if="isExporting" aria-hidden="true" role="status"
                                    class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin"
                                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="#E5E7EB" />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentColor" />
                                </svg>
                                {{ isExporting ? 'Exporting...' : 'Export' }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="Object.keys(viewTotalOrdersData).length">
                    <table id="summaryDataTable" class="tw-w-full tw-mt-3 tw-min-h-[100px]">
                        <thead>
                            <tr>
                                <th v-for="(item, index) in viewTotalOrdersData.headers" :key="index">
                                    <span>{{ item.key }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, idx) in viewTotalOrdersData.data" :key="idx"
                                v-if="item.key != 'Total'">
                                <td v-for="(head, index) in viewTotalOrdersData.headers" :key="index">
                                    {{ formatNumber(item[head.value]) }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                             <tr>
                                <th v-for="(th, idx) in viewTotalOrdersData.headers" :key="th.value">
                                    <div v-if="th.value === 'time_breakup'">Total</div> 
                                    <div v-else></div>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div v-else class="tw-min-h-[400px]">
                    <noData :loaderVariable="totalOrderLoader" />
                </div>
                </div>
        </div>

    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";
import dynamicChart from "../commonCharts/Chart/dynamicChart.vue";
import pieChart from "../commonCharts/Chart/commonPieChart.vue";
import StateMapper from '../commonCharts/IndiaState.json'
import indiaMap from "../commonCharts/IndiaMap.vue";
import stackChart from "../commonCharts/StackChart.vue";
import noData from "../Components/noData.vue";
export default {
    name: "Total Orders",
    components: { Datepicker, Multiselect, Loader, dynamicChart, pieChart, indiaMap, stackChart, noData },
    data: function () {
        return {
            dropownLoader: false,
            dateRange: {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            channelList:'',
            selectedChannel:'',
            // Loader Section start
            isExporting: false,
            isAllDownload: false,
            totalOrderLoader:false,
            // loader Section end
            maxDate: new Date(),
            viewTotalOrdersData:{},
            dataForExport:{},
            selectedInterval: '60'
        };
    },
    mounted() {
        // this.getDropdownData();
        this.getDropdownData();
        this.$store.dispatch("DemoStore/setTimeStamp", '');
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");

    },
    watch:{
         selectedInterval: function () {
            this.getDailyRunRateData();
            // this.getDailyData();
        },
    },

    methods: {

        dataAPIs() {
            if ($.fn.DataTable.isDataTable('#summaryDataTable')) {
                $('#summaryDataTable').DataTable().destroy();
            }
            this.getDailyRunRateData();
          
        },

        formateDate() {
            this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
            this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
            this.dataAPIs();
        },

        formatNumber(num) {
            if (isNaN(num)) return num
            let num1 = Number(num).toFixed(2);
            let num2 = Number(num1).toLocaleString();
            return num2
        },


        getDropdownData() {
            this.dropownLoader = true;
            const url = "/api/unicommerce/filters/";
            this.$http
                .get(url)
                .then((response) => {
                    this.channelList = response.data.data.Channel;
                    this.selectedChannel = this.channelList[0]
                    this.dropownLoader = false;
                    this.dataAPIs();
                })
                .catch((error) => {
                    this.dropownLoader = false;
                    console.error("Error fetching warehouse data:", error);
                });
        },

        getDailyRunRateData(){
            this.totalOrderLoader = true
            this.viewTotalOrdersData = ''
            let url = "/api/unicommerce/daily_run_rate?start_date="+this.dateRange.startDate
            url += "&end_date="+this.dateRange.endDate
            url += "&channel="+this.selectedChannel.key
            url += "&breakup="+this.selectedInterval
            this.$http.get(url).then(response => {
                this.viewTotalOrdersData = response.data.data;
                this.dataForExport = response
                this.totalOrderLoader = false
                this.$nextTick(()=>{
                    // this.processTable("#summaryDataTable")
                    this.processFooterTable("#summaryDataTable")    
                })
            })
        },
      
        exportTotalOrdersData() {
            const url = "/api/unicommerce/export/xlsx";
            this.$http.post(url, this.dataForExport.data)
                .then((response) => {
                    window.location = response.data?.url;
                    this.isExporting = false;
                })
                .catch((error) => {
                    this.isExporting = false;
                    console.error("Error exporting data:", error);
                });
        },
      
           processFooterTable(id) {
            // var search = require("/Icons_SVG/Search.svg");
            let self = this;
            $(id).DataTable({
                info: false,
                searching: true,
                info: true,
                ordering: true,
                order: [],
                "pageLength": 25,
                columnDefs: [
                    {
                        targets: 0,
                        className: "min-width-column",
                    },
                ],
                initComplete: function (settings, json) {
                    $('.dataTables_scrollBody tfoot tr').css({ visibility: 'collapse' });
                    $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
                    $(id).wrap("<div style='overflow:auto; width:100%;position:relative;'></div>");
                },
                language: {
                    paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                        
                    },
                    search: "",
                    searchPlaceholder: "Search",
                    lengthMenu: "<h5>Show entries</h5> _MENU_"
                },

                footerCallback: function (row, data, start, end, display) {
                    var api = this.api();
                    // Remove the formatting to get integer data for summation
                    var intVal = function (i) {
                        return typeof i === 'string' ?
                            parseFloat(i.replace(/,/g, '')) * 1 :
                            typeof i === 'number' ?
                                i : 0;

                    };

                    for (let i = 1; i < self.viewTotalOrdersData.headers.length; i++) {
                        let data = api.column(i, { search: 'applied', page:'current', sorting:'applied' }).data();
                        if (data.length) {
                            var total = ''
                            total = data.reduce(function (a, b) {
                                return intVal(a) + intVal(b);
                            });
                        } else {
                            total = 0;
                        }
                        if(total==0){
                            // $(api.column(i).footer()).children('div').html("-").addClass('text-center')
                            $(api.column(i).footer()).html('0')
                        }else{
                            $(api.column(i).footer()).html(self.formatNumber(total))
                        }
                        // total === 0 ?
                        //     $(api.column(i).footer()).children('div').html("-").addClass('text-center') :
                        //     $(api.column(i).footer()).html(self.formatNumber(total));
                    }
                }
            });
            $(id + "_filter > label").append(
                `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
            );
        },
        processTable(id) {
            $(id).DataTable().destroy();
            $(id).DataTable({
                searching: true,
                info: true,
                ordering: true,
                order: [],
                "pageLength": 25,
                columnDefs: [
                    {
                        targets: 0,
                        className: "min-width-column",
                    },
                ],
                initComplete: function () {
                    $(id).wrap(
                        "<div style='overflow:auto; width:100%;position:relative;'></div>"
                    );
                },
                language: {
                    search: "",
                    searchPlaceholder: "Search...",
                    paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                    },
                    lengthMenu: "<h5>Show entries</h5> _MENU_",
                },
            });
            $(id + "_filter > label").append(
                `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
            );
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card {
    /* margin-bottom: 1rem !important; */
}

.exportButton {
    margin-left: 6px;
    /* height: 35px; */
    border: none;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-weight: 600;
    padding: 0px 25px;
    letter-spacing: 0.2px;
}

.tab-label {
    cursor: pointer;
    padding-bottom: 12px;
    transition: all 0.3s ease;
    font-size: 16px;
    font-weight: 500;
}

.tab-label.active {
    color: rgba(6, 85, 89, 1);
    border-bottom: 1px solid rgba(6, 85, 89, 1);
    font-weight: 600 !important;
}

.stepper-container {
    padding: 20px;
    font-family: sans-serif;
}

.steps {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.step {
    font-weight: 600;
    color: #999;
}

.step.active {
    color: #065559;
    font-weight: bold;
}

.step-circle.active {
    background-color: #065559;
    color: white;
    padding: 10px;
    border-radius: 50%;
}

.line {
    flex-grow: 1;
    height: 2px;
    background-color: #ccc;
    margin: 0 10px;
}

.input-box {
    width: 100%;
    padding: 10px;
    border: 1px solid #aeaeae;
    border-radius: 5px;
    margin-bottom: 16px;
}

.suggestions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.sku-pill {
    border: 1px solid #aeaeae;
    border-radius: 20px;
    padding: 6px 12px;
    background: white;
    cursor: pointer;
}

.button-group {
    text-align: right;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}
</style>
<style>
@media only screen and (max-width: 600px) {
    .daterangepicker .drp-calendar {
        display: none;
        max-width: 270px;
        width: 240px;
    }
}

.vue-daterange-picker .daterangepicker div.ranges {
    min-width: 94px;
}

.daterangepicker.opensright[data-v-1ebd09d2] {
    left: 0px;
    right: auto;
}


#werehouseDateRange .multiselect__tags {
    border: 1px solid #ccc !important;
    max-height: 20px !important;
}

#werehouseDateRange .reportrange-text {
    height: 34px !important;
    width: 180px !important;
}

#werehouseDateRange .reportrange-text span {
    font-size: 16px !important;
}

.borderBetweenTab {
    border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
    margin-bottom: 15px !important;
}
</style>